
import CategoryProject from '../components/display/CategoryProject.vue'
import { ref, computed, defineComponent, ComputedRef } from 'vue'
import { useStore, PROJECT_STORE_SYMBOL } from '../store'

import { colorLog } from '../utils/colorLog'
import { ICategoryName } from '../interfaces/ICategory'
import { IProject } from '../interfaces/IProject'
import { ProjectStore } from '../store/project/project.store'
import { PROJECTS } from '../store/project/constants'
import { Session } from '../store/session/session.interface'

export default defineComponent({
  components: {
    CategoryProject
  },
  async setup() {
    const categories: ICategoryName[] = ['browser', 'deno', 'faas', 'nodejs', 'rust', 'ssvm', 'tencentcloud']

    const selectedCategory = ref<ICategoryName>('nodejs')

    const projectStore: ProjectStore = useStore<ProjectStore>(PROJECT_STORE_SYMBOL) as ProjectStore

    // sometimes the inject doesn't work 
    if(!projectStore) {
      location.reload()
    }

    // if (!projectStore.getState().records.loaded) {
    //   await projectStore.fetchRecords()
    // }
    
    const allProjects: IProject[] = await projectStore.loadRecords(PROJECTS)

    const projects: ComputedRef<IProject[]> = computed(() => allProjects.filter(project => {
      return project.categoryName == selectedCategory.value
    }))

    const setCategory = (category: ICategoryName) => {
      selectedCategory.value = category
    }
    // colorLog('projects')
    // console.log(projects.value);
    // console.log(projectStore.getRecordById('hello-rust'));
    
    const session = new Session('a', 'b', projectStore)
    session.endSession()

    return {
      categories,
      selectedCategory,
      setCategory,
      projects
    }
  }
})
